<template>
    <gridComponent :loader="loader" :items="items" :itemsData="itemsData" :headers="headers"
        :ColonneWidth="['30%', '10%', '20%', '15%', '15%', '10%', '15%']" :GetFunction="getMasterOrdersList">
        <!-- Filters -->
        <template v-slot:[SlotsFilters.Filter0]>
            <ColumnFilter :title="$t('masterOrders.productName')" :Filter="productName" @cancel="productName = null"
                :getList="getMasterOrdersList">
                <template v-slot:input>
                    <v-text-field v-model="productName" id="productName" variant="outlined" maxlength="33"
                        hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter1]>
            <ColumnFilter :title="$t('masterOrders.unitPrice')" :Filter="UnitPrice" @cancel="UnitPrice = null"
                :getList="getMasterOrdersList">
                <template v-slot:input>
                    <v-text-field v-model="UnitPrice" variant="outlined" maxlength="33" hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter2]>
            <ColumnFilter :title="$t('masterOrders.creationDate')" :Filter="CreationDate" @cancel="CreationDate = null"
                :getList="getMasterOrdersList">
                <template v-slot:input>
                    <span lang="en-CA" xml:lang="en-CA">
                        <dateField v-model="CreationDate" :min-date="new Date('2000-01-01')" :max-date="new Date()" />
                    </span>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter3]>
            <ColumnFilter :title="$t('masterOrders.totalQuantity')" :Filter="TotalQuantity"
                @cancel="TotalQuantity = null" :getList="getMasterOrdersList">
                <template v-slot:input>
                    <v-text-field v-model="TotalQuantity" variant="outlined" type="number" hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter4]>
            <ColumnFilter :title="$t('masterOrders.totalPrice')" :Filter="TotalAmount" @cancel="TotalAmount = null"
                :getList="getMasterOrdersList">
                <template v-slot:input>
                    <v-text-field v-model="TotalAmount" variant="outlined" type="number" hide-details></v-text-field>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter5]>
            <ColumnFilter :title="$t('masterOrders.status')" :Filter="Status" @cancel="Status = null"
                :getList="getMasterOrdersList">
                <template v-slot:input>
                    <v-radio-group v-model="Status" column>
                        <v-radio :label="$t('masterOrders.statusList.pending')" :value="0"></v-radio>
                        <v-radio :label="$t('masterOrders.statusList.confirmed')" :value="1"></v-radio>
                    </v-radio-group>
                </template>
            </ColumnFilter>
        </template>

        <template v-slot:[SlotsFilters.Filter6]>
            <ColumnFilter :title="$t('masterOrders.endCollectionTime') + ' 🕒'" :Filter="CollectionTime"
                @cancel="resetDuration" :getList="getMasterOrdersList">
                <template v-slot:input>
                    <span lang="en-CA" xml:lang="en-CA">
                        <DurationPicker v-model="durationModel" @durationChange="onDurationChange" :debug="false" />
                    </span>
                </template>
            </ColumnFilter>
        </template>

        <!-- Data Rows -->
        <template v-slot:[SlotsItems.item0]="{ item }">{{ item.productName }}</template>
        <template v-slot:[SlotsItems.item1]="{ item }">{{ formatPrice(item.unitPrice) }}</template>
        <template v-slot:[SlotsItems.item2]="{ item }">{{ formatDate(item.startDateTime) }}</template>
        <template v-slot:[SlotsItems.item3]="{ item }">{{ item.quantity }}</template>
        <template v-slot:[SlotsItems.item4]="{ item }">{{ formatPrice(item.totalPrice) }}</template>
        <template v-slot:[SlotsItems.item5]="{ item }">
            <StatusButton v-if="item" :title="getStatusText(item.status)" :color="getStatusColor(item.status)" />
        </template>
        <template v-slot:[SlotsItems.item6]="{ item }">
            <CountdownTimer v-if="item.endDateTime" :endTime="item.endDateTime" />
            <span v-else>{{ $t('masterOrders.NotCollectingYet') }}</span>
        </template>

        <!-- Actions -->
        <template v-slot:edit="{ item, index }">
            <MasterOrderItemMenu :Id="index" :masterOrderId="item.masterOrderId"
                :getMasterOrdersAfterDeleted="getMasterOrdersList" :itemTitle="item.productName"
                :DestroyTimer="item.status === 0" />
        </template>
    </gridComponent>
</template>

<script>
import DurationPicker from '@/genericComponent/durationPicker.vue';
import gridComponent from "@/genericComponent/gridComponent.vue";
import ColumnFilter from "@/genericComponent/ColumnFilter.vue";
import dateField from "@/genericComponent/date-field.vue";
import StatusButton from "@/genericComponent/StatusButton.vue";
import { formatPrice, getMasterOrders } from "@/api/index";
import CountdownTimer from "@/genericComponent/countdownTimer.vue";
import MasterOrderItemMenu from "./MasterOrderItemMenu.vue";
export default {
    components: {
        gridComponent,
        ColumnFilter,
        dateField,
        StatusButton,
        CountdownTimer,
        DurationPicker,
        MasterOrderItemMenu
    },
    data() {
        return {

            durationModel: {
                years: 0,
                months: 0,
                days: 0,
                hours: 0,
                minutes: 0
            },
            loader: true,
            page: 1,
            pageSize: 10,
            items: [],
            itemsData: {},
            search: null,
            productName: null,
            UnitPrice: null,
            TotalQuantity: null,
            Status: null,
            TotalAmount: null,
            CreationDate: null,
            CollectionTime: null,
            SortedBy: null,
            SortingType: null,

        };
    },
    created() {
        this.getMasterOrdersList();
    },
    mounted() {
        this.emitter.off("event-test");
        this.emitter.emit("remise-search-at-null");
        this.emitter.on("event-test", (event) => {
            this.search = event;
            this.getMasterOrdersList();
        });
    },
    unmounted() {
        this.emitter.off("event-test");
        this.emitter.emit("remise-search-at-null");
    },
    methods: {
        formatPrice(price) {
            return formatPrice(price)
        },
        resetDuration() {
            this.CollectionTime = null;
            this.durationModel = {
                years: 0,
                months: 0,
                days: 0,
                hours: 0,
                minutes: 0
            };
        },
        onDurationChange(durationData) {

            this.CollectionTime = {
                value: durationData.formattedDuration,
                dateTimeUtc: durationData.dateTimeUtc,
                dateTimeTicks: durationData.dateTimeTicks,
                duration: {
                    years: durationData.years,
                    months: durationData.months,
                    days: durationData.days,
                    hours: durationData.hours,
                    minutes: durationData.minutes
                }
            };
        },

        onCancelEndCollectionTime() {
            this.CollectionTime = null;
            this.durationModel = {
                years: 0,
                months: 0,
                days: 0,
                hours: 0,
                minutes: 0
            };
        },

        getMasterOrdersList(page) {
            if (page) {
                this.page = page;
            }
            getMasterOrders(
                this.page,
                this.pageSize,
                this.SortedBy,
                this.SortingType,
                this.search,
                this.productName,
                this.TotalQuantity,
                this.Status,
                this.UnitPrice,
                this.TotalAmount,
                this.CreationDate,
                this.CollectionTime
            ).then((response) => {
                this.items = response.data.items;
                this.itemsData.numberOfPage = response.data.totalPages;
                this.itemsData.totalItemsCount = response.data.totalCount;
                this.itemsData.pageNumber = response.data.pageNumber;
                this.itemsData.hasPreviousPage = response.data.hasPreviousPage;
                this.itemsData.hasNextPage = response.data.hasNextPage;
                this.loader = false;
            });
        },
        onSearch(searchTerm) {
            this.search = searchTerm;
            this.getMasterOrdersList();
        },
        getStatusText(status) {
            switch (status) {
                case 0:
                    return this.$t("masterOrders.statusList.pending");
                case 1:
                    return this.$t("masterOrders.statusList.confirmed");
                default:
                    return this.$t("masterOrders.statusList.unknown");
            }
        },
        getStatusColor(status) {
            switch (status) {
                case 0:
                    return "#C5CDD4"; // Gray for 'Pending'
                case 1:
                    return "#114EF7"; // Blue for 'Confirmed'
                default:
                    return "#C5CDD4"; // Default Gray
            }
        },
        formatDate(dateString) {

            const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

            const utcDateString = dateString.replace(' ', 'T') + 'Z';
            const utcDate = new Date(utcDateString);

            const localDate = new Date(utcDate.toLocaleString('en-US', { timeZone: userTimeZone }));

            const year = localDate.getFullYear();
            const month = String(localDate.getMonth() + 1).padStart(2, '0');
            const day = String(localDate.getDate()).padStart(2, '0');
            const hours = String(localDate.getHours()).padStart(2, '0');
            const minutes = String(localDate.getMinutes()).padStart(2, '0');
            const seconds = String(localDate.getSeconds()).padStart(2, '0');
            const formattedDateTime = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;

            return formattedDateTime;
        },
    },
    computed: {
        headers() {
            return [
                this.$t("masterOrders.productName"),
                this.$t("masterOrders.unitPrice"),
                this.$t("masterOrders.creationDate"),
                this.$t("masterOrders.totalQuantity"),
                this.$t("masterOrders.totalAmount"),
                this.$t("masterOrders.status"),
                this.$t("masterOrders.endCollectionTime"),
            ];
        },
        SlotsItems() {
            const items = {
                item0: "item",
                item1: "item",
                item2: "item",
                item3: "item",
                item4: "item",
                item5: "item",
                item6: "item",
            };
            let i = 0;
            for (const key in items) {
                items[key] = "item" + i;
                i = i + 1;
            }
            return items;
        },
        SlotsFilters() {
            const filters = {
                Filter0: "Filter",
                Filter1: "Filter",
                Filter2: "Filter",
                Filter3: "Filter",
                Filter4: "Filter",
                Filter5: "Filter",
                Filter6: "Filter",
            };
            let i = 0;
            for (const key in filters) {
                filters[key] = "Filter" + i;
                i = i + 1;
            }
            return filters;
        },
    },
    watch: {
        search() {
            this.getMasterOrdersList();
        },
    },
};
</script>

<style scoped>
.v-card-title {
    color: #001e50;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.text-basil {
    color: #114ef7 !important;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    font-family: inter;
}

.slider {
    font-family: "Inter";
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    flex: content;
    border-bottom: "2px solid black";
}

.disabled {
    opacity: 0.5;
    pointer-events: none;
}
</style>
